<template>
	<div class="BooleanField" :class="{ error }">
		<input type="radio" v-model="model" :name="id" :id="id + 'Y'" :value="true" @focus="onFocus" @blur="onBlur" :disabled="disabled" />
		<label :for="id + 'Y'">{{ trueLabel }}</label>
		<input type="radio" v-model="model" :name="id" :id="id + 'N'" :value="false" @focus="onFocus" @blur="onBlur" :disabled="disabled" />
		<label :for="id + 'N'">{{ falseLabel }}</label>
		<span class="clear" v-if="!disabled && value !== undefined && value !== null" @click="$emit('input', undefined)">
			Clear
		</span>
	</div>
</template>

<script>
import { field } from './FieldMixin.js'

export default {
	name: 'BooleanField',
	mixins: [ field ],
	props: {
		value: Boolean,
	},
	data: () => ({
		id: 'RG-' + Math.random(),
		model: undefined,
	}),
	computed: {
		trueLabel() {
			return this.control?.settings?.trueLabel ?? 'Yes'
		},
		falseLabel() {
			return this.control?.settings?.falseLabel ?? 'No'
		},
	},
	watch: {
		// TODO: on initial load this does not fire!
		value(n) {
			this.model = n
			this.validate()
		},
	},
	methods: {
		validate() {
			this.onErrors([
				this.validateRequired(),
			])
		},
	},
	mounted() {
		this.validate()
	},
}
</script>

<style scoped>
label { padding-left: 5px; margin-right: 15px; }
.clear { color: rgb(0, 89, 200); padding-left: 20px; cursor: pointer; }
</style>